<!--
 * @Author: luxiangqiang
 * @Date: 2023-04-26 14:08:33
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-04-27 11:08:56
-->
<template>
  <div class="calculation-wrapper">
    <div class="title">{{ title }}</div>

    <div class="calculation">
      <a-form class="form" ref="formRef" size="large" :model="formData">
        <a-input-group>
          <a-form-item
            field="jobTitle"
            :rules="[{ required: true, message: '职位为必选' }]"
            :validate-trigger="['change']"
            hide-asterisk
          >
            <a-select :style="{ width: '220px' }" v-model="formData.jobTitle" placeholder="请选择职位" allow-search>
              <a-option v-for="job in salaryToolJobList" :key="job.value" :value="job.value">{{
                locale === 'zh-CN' ? job.label : job.value
              }}</a-option>
              <template #prefix>
                <div class="amount-prefix">{{ $t('职位') }}</div>
              </template>
            </a-select>
          </a-form-item>
          <a-form-item
            class="country-select"
            field="countryCode"
            :rules="[{ required: true, message: '国家为必填' }]"
            :validate-trigger="['change']"
            hide-asterisk
          >
            <a-select
              v-model="formData.countryCode"
              :options="concatCountryList"
              :style="{ width: '150px' }"
              placeholder="请选择国家"
            >
              <template #label="{ data: item }">{{ locale === 'zh-CN' ? item.label : item.enLabel }}</template>
              <template #option="{ data: item }">{{ locale === 'zh-CN' ? item.label : item.enLabel }}</template>
            </a-select>
          </a-form-item>
          <a-button type="primary" @click="handleCalc" class="pc_button">
            开始计算
            <img style="width: 25px" src="@/assets/icons/arrow.svg" alt="arrow" />
          </a-button>
        </a-input-group>
      </a-form>
    </div>
    <a-button type="primary" @click="handleCalc" class="mobile_button">
      开始计算
      <img style="width: 25px" src="@/assets/icons/arrow.svg" alt="arrow" />
    </a-button>
  </div>
</template>

<script setup lang="ts">
import { salaryToolCountryList } from '@/common/global';
import { FormInstance } from '@arco-design/web-vue';
import { salaryToolJobList } from '@/common/global';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const formRef = ref<FormInstance | null>(null);
const concatCountryList = salaryToolCountryList;

const props = defineProps<{
  title: string;
  countryCode: string;
  jobTitle: string;
}>();

const emits = defineEmits<{
  (e: 'update:countryCode', countryCode: string): void;
  (e: 'update:jobTitle', jobTitle: string): void;
}>();

const route = useRoute();

const jobTitle = computed({
  get() {
    return props.jobTitle;
  },
  set(value: string) {
    emits('update:jobTitle', value);
  },
});
const countryCode = computed({
  get() {
    return props.countryCode;
  },
  set(value: string) {
    emits('update:countryCode', value);
  },
});
const formData = reactive({
  countryCode,
  jobTitle,
});

const handleCalc = async () => {
  const res = await formRef.value?.validate();
  if (res) {
    return false;
  }
  // const countryName = concatCountryList.find(c => c.label === formData.countryCode)?.label;
  // useLogger().track('calculator', {
  //   country: countryName,
  //   salary: formData.amount
  // });

  await navigateTo(
    {
      path: route.path,
      query: {
        ...route.query,
        jobTitle: jobTitle.value,
        countryCode: countryCode.value,
      },
    },
    { replace: true }
  );
  window.location.reload();
};
</script>

<style scoped lang="less">
:deep(.arco-form-item-label-col) {
  display: none;
}

:deep(.arco-form-item-message) {
  margin-bottom: -30px;
}

:deep(.arco-col-19) {
  flex: 1;
}

:deep(.arco-row) {
  width: 170px;
}

.calculation-wrapper {
  padding-top: 25px;
  width: 680px;

  .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: #1d2129;
  }

  :deep(.arco-row) {
    margin-bottom: 0;
  }

  .calculation {
    margin-top: 20px;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    width: fit-content;
    display: flex;
    align-items: center;
    height: 40px;
    padding: 4px;
    box-sizing: border-box;
    background-color: #fff;

    .country-select {
      :deep(.arco-select-view-single::after) {
        display: none !important;
      }

      :deep(.arco-select) {
        width: 170px !important;
      }
    }

    :deep(.arco-input-wrapper),
    :deep(.arco-input-focus) {
      border: 0;
    }

    :deep(.arco-select-view-single) {
      position: relative;
      background-color: #fff;
      border: 0;

      &::after {
        position: absolute;
        top: 20%;
        right: 0;
        content: '';
        display: block;
        width: 1px;
        height: 20px;
        background-color: #e5e6eb;
      }
    }

    :deep(.arco-input-wrapper) {
      background-color: #fff;
    }
  }
}

@media screen and (min-width: 800px) {
  .mobile_button {
    display: none;
  }
}

@media screen and (max-width: 800px) {
  .calculation-wrapper {
    padding: 0 16px;
    width: fit-content;
  }
  .pc_button {
    display: none;
  }
  .mobile_button {
    margin-top: 16px;
  }
}
</style>
